export default
`


            ╗╔╗╔╔╗╔╗
            ╠╣║║║╗║║
            ╝╚╚╝╚╝╚╝$version
        Application Assistent
`